import PropTypes from "prop-types";
import { isMobile } from "react-device-detect";

const Testimonial = ({ data }) => {
    return (
        <div className="single-testimonial">
            <i className={data.icon}></i>

            <div
                className="testimonial-content"
                style={{
                    textAlign: isMobile ? "center" : "start",
                }}
            >
                <p>{data.excerpt}</p>
            </div>
        </div>
    );
};

Testimonial.propTypes = {
    data: PropTypes.object,
};

export default Testimonial;
